/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { VATTotalPrice } from 'api/common-types'
import { CurrencySymbol } from 'api/models/Common/JyrneyEnums'

type DisplayPriceProps = {
  priceType?: 'exact' | 'range'
  VATTotalPrice: VATTotalPrice | undefined
  displayVATPrice: boolean
  justify?: any
  fontWeight?: string | number
  strikeThrough?: boolean
}

export const displayPriceFunction = (
  VATTotalPrice: VATTotalPrice | undefined,
  displayVATPrice: boolean,
) => {
  if (VATTotalPrice === undefined) {
    return
  }
  const priceValue = displayVATPrice ? VATTotalPrice.total : VATTotalPrice.price

  const exactPrice = Number(priceValue).toFixed(2)
    ? Number(priceValue).toFixed(2)
    : '0.00'
  const currencySymbolLookup =
    CurrencySymbol[VATTotalPrice.currency as keyof typeof CurrencySymbol]
  const currencySymbolValue = currencySymbolLookup ? currencySymbolLookup : ''
  return {
    currencySymbolValue,
    exactPrice,
  }
}
const DisplayPrice = ({
  VATTotalPrice,
  priceType,
  displayVATPrice,
  justify = 'flex-start',
  fontWeight = '400',
  strikeThrough = false,
}: DisplayPriceProps) => {
  const response = displayPriceFunction(VATTotalPrice, displayVATPrice)
  if (!response) return '-'
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2px',
        alignItems: 'baseline',
        justifyContent: justify,
      }}
    >
      <Typography
        sx={{
          fontSize: '100%',
          fontWeight,
          ...(strikeThrough && { textDecoration: 'line-through' }),
        }}
      >{`${response.currencySymbolValue}${response.exactPrice}`}</Typography>
      <Typography
        sx={{
          fontSize: '70%',
          textWrap: 'nowrap',
          fontWeight,
          ...(strikeThrough && { textDecoration: 'line-through' }),
        }}
      >{`${displayVATPrice ? 'inc. VAT' : 'ex. VAT'}`}</Typography>
    </Box>
  )
}
export default DisplayPrice
